import { createSelector } from '@reduxjs/toolkit';

/**
 * Memoized selector that combines all Reports Schedule page data.
 * Prevents unnecessary re-renders by only updating when actual data changes.
 */
export const selectReportsSchedulePageContext = createSelector(
  [(state: any) => state.reportsStore, (state: any) => state.userStore, (state: any) => state.accountsStore],
  (reportsStore, userStore, accountsStore) => ({
    // User context
    loggedInUser: userStore.loggedInUser,
    assignedGrandfatherClientNumber: userStore.assignedGrandfatherClientNumber,
    assignedAccountNumber: userStore.assignedAccountNumber,
    canReadWrite: userStore.canReadWriteReports,

    // Accounts data
    allAccounts: accountsStore.allAccounts,

    // Scheduled reports list
    scheduledReportsList: reportsStore.scheduledReportsList,
    scheduledReportsListLoaded: reportsStore.scheduledReportsListLoaded,
    scheduledReportsListError: reportsStore.scheduledReportsListError,
    scheduledReportsListLoading: reportsStore.scheduledReportsListLoading,
    scheduledReportsResultSize: reportsStore.scheduledReportsListResultSize,

    // Single scheduled report
    scheduledReport: reportsStore.scheduledReport,
    scheduledReportLoading: reportsStore.scheduledReportLoading,

    // CRUD operation completion flags
    deleteScheduledReportLoaded: reportsStore.deleteScheduledReportLoaded,
    createScheduledReportLoaded: reportsStore.createScheduledReportLoaded,
    updateScheduledReportLoaded: reportsStore.updateScheduledReportLoaded,
    enableScheduledReportLoaded: reportsStore.enableScheduledReportLoaded,
    disableScheduledReportLoaded: reportsStore.disableScheduledReportLoaded,

    // CRUD operation loading states
    createScheduledReportLoading: reportsStore.createScheduledReportLoading,
    updateScheduledReportLoading: reportsStore.updateScheduledReportLoading,
    enableScheduledReportLoading: reportsStore.enableScheduledReportLoading,
    disableScheduledReportLoading: reportsStore.disableScheduledReportLoading,
  })
);
